class MonoService {
    static loadScript() {
        return new Promise((resolve, reject) => {
            const src = 'https://connect.withmono.com/connect.js';

            // Only run if mono script has not been added to the body
            if (!document.querySelector(`[src="${src}"]`)) {
                const scriptElement = document.createElement('script');
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                scriptElement.src = src;
                document.body.appendChild(scriptElement);
            } else {
                resolve();
            }
        });
    }

    static async getConnect(config, countryCode) {
        await this.loadScript();

        const keys = {
            NG: process.env.MIX_MONO_NG_PUBLIC_KEY,
            GH: process.env.MIX_MONO_GH_PUBLIC_KEY,
            KE: process.env.MIX_MONO_KE_PUBLIC_KEY,
            ZA: process.env.MIX_MONO_ZA_PUBLIC_KEY,
        };

        const connect = new Connect({
            key: keys[countryCode],
            ...config,
        });

        return connect;
    }
}

export default MonoService;
